package org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.init_search_bill


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)